



























































import { Vue, Component, Prop } from 'vue-property-decorator'
import * as shifts from '@/services/shifts'
import { Shift } from '@/types/Jobs'
import { ClockAction } from '@/types/Jobs'

import ClockInDialog from '@/views/clock/ClockInDialog.vue'

@Component({
  components: {
    ClockInDialog,
  },
})
export default class ClockButtons extends Vue {
  
  @Prop({ type: Object }) readonly shift!: Shift
  @Prop({ default: false }) readonly large!: boolean

  clockInDialog = false
  tasksNotCompletedDialog = false
  togglingClock = false
  togglingBreak = false

  clockIn() {
    this.clockInDialog = true
  }

  async clockOut(forceOut = false) {
    this.togglingClock = true
    
    const allTasksCompleted = this.shift.tasks.reduce((acc, task) => {
      return acc && task.complete
    }, true)

    try {
      if (!allTasksCompleted && !forceOut) {
        this.tasksNotCompletedDialog = true
      } else {
        await shifts.clockOut(this.$store, this.shift.id)
        this.tasksNotCompletedDialog = false
        this.togglingClock = false
      }
    }
    finally {
      this.togglingClock = false
    }
  }

  async toggleBreak() {
    this.togglingBreak = true
    await shifts.toggleBreak(this.$store, this.shift.id, !this.onBreak)
    this.togglingBreak = false
  }

  get clocked() {
    if (this.shift.clock_state === null) return false
    return this.shift.clock_state != ClockAction.ClockOut
  }

  get onBreak() {
    if (this.shift.clock_state === null) return false
    return this.shift.clock_state == ClockAction.StartBreak
  }

  get iAmVerified() {
    return this.$store.getters.iAmVerified
  }

}
